import { useTheme } from "../hooks/useTheme";


type Props = {
    data: any[];
    dateType?: string;
}

export const FinancleCardPresentation = ({ data, dateType }: Props) => {
    const { themeStyles } = useTheme();
    const getVsLabel = (dateType: string) => {
        if (dateType === "Today" || dateType === "Yesterday") return "vs Previous Day";
        if (dateType === "This Week") return "vs Previous Week";
        if (dateType === "This Month" || dateType === "Last Month") return "vs Previous Month";
        if (dateType === "This Year" || dateType === "Last Year") return "vs Previous Year";
        return "vs Previous Date Range";
    };

    return (
        <div className="flex flex-row flex-wrap gap-2">
            {
                data?.map((item: any, index: number) => (
                    <div key={index} className={`flex flex-col px-[12px] py-[14px] gap-3.5 md:w-[24%] sm:w-[16%] border ${themeStyles.main.borderColor} rounded-[16px] bg-transparent`}>
                        <div className="w-full">
                            <span className={`md:text-[14px] sm:text-[10px] ${themeStyles.main.textSubHeadingColor} font-semibold`}>{item?.label}</span>
                        </div>
                        <div className="w-full flex justify-between items-start">
                            <span className={`md:text-[20px] sm:text-[16px] ${themeStyles.main.textHeadingColor} font-bold`}>{item?.symbol}{item?.count}</span>
                            {
                                item.vsLastMonthPercentage != null && (
                                    <div className="flex flex-col gap-1.5">
                                        <div className="flex  items-end h-full">
                                            <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${item?.vsLastMonthPercentage > 0 ? "bg-[#D9F4D4] text-[#039855]" : "bg-[#FEDFDD] text-[#D92D20]"} `}>
                                                {item?.vsLastMonthPercentage > 0 ? "+" + item?.vsLastMonthPercentage : item?.vsLastMonthPercentage}%
                                            </span>
                                        </div>
                                        <span className={`md:text-[11px] sm:text-[8px] font-semibold break-words max-w-[100px] ${themeStyles.main.textSubHeadingColor}`}>
                                            {getVsLabel((dateType && dateType) || "")}
                                        </span>

                                    </div>
                                )
                            }

                        </div>
                    </div>
                ))
            }
        </div>
    )
}